<article
  class="w-full ci-main-padding fadeinup animation-duration-500 flex justify-content-between fixed top-0 z-5">
  <section class="flex">
    <section class="ci-bg-glass--purple flex justify-content-center align-items-center shadow-3 border-round-bottom-lg"
      (click)="showMenu()">
      <i class="bi bi-filter-left ci-txt--white cursor-pointer mx-1 text-6xl"></i>
    </section>
  </section>

  <section *ngIf="showLogo" class="hidden md:flex ci-bg-glass--black border-round-bottom-lg shadow-3">
    <img src="assets/images/logo/logoColor.png"
      alt="Somos innovacion logo" class="h-2rem md:h-3rem my-2">
  </section>
</article>